import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Popconfirm,
  Radio,
  Row,
  Select,
  Space,
  Upload,
} from "antd";
import React from "react";
import "./style.css";
import { localhost } from "../../../../server_url";
import {
  DeleteOutlined,
  ReloadOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  validateMessages,
  disabledDate,
  openNotificationWithIcon,
} from "../../../Function";
import moment from "moment";
import Cookies from "universal-cookie";
import { authAxios } from "../../../../utils";
import { url_download_note_cv } from "../../../../constants";
const cookies = new Cookies();

const dateFormat = "DD/MM/YYYY";

const ModalEditCandidate = ({
  typeEditForm,
  dataDetailCandidate,
  onFinishEdit,
  form,
  isModalOpenEditCandidate,
  handleCancelEditCandidate,
  onChangeCheckBoxGender,
  ls_city,
  listDistrict,
  handleChangeListCity,
  selectedDistrict,
  setSelectedDistrict,
  listEducationLevel,
  // listLanguageSkill,
  listCandidateSource,
  handleChangeUploadCV,
  uploadFileCV,
  listStatusCV,
  onReloadNote,
  dataNoteCV,
  loadingNote,
  onDeleleFileCV,
  handleChangeUploadNote,
}) => {
  const handleClickUserReceived = (e) => {
    // Ngăn người dùng chọn giá trị
    e.preventDefault();
    e.stopPropagation();
  };

  const ComponentUploadFile = ({}) => {
    return (
      <>
        <Upload
          accept=".doc, .docx, .pdf"
          onChange={handleChangeUploadCV}
          fileList={uploadFileCV}
          className=""
          maxCount={1}
          beforeUpload={(file) => {
            const checkSize = file.size / 1024 / 1024 > 10;
            if (checkSize) {
              openNotificationWithIcon("error", "Lỗi", `File CV đã quá 10MB !`);
              return Upload.LIST_IGNORE;
            }

            form.setFieldsValue({
              file_upload: file.name,
            });
            return false;
          }}
          showUploadList={false}
          disabled={!typeEditForm}
        >
          <span style={{ cursor: "pointer" }}>
            <UploadOutlined /> Tải lên
          </span>
        </Upload>
      </>
    );
  };

  const ComponentUploadFileNote = ({}) => {
    return (
      <>
        <Upload
          accept=".doc, .docx, .pdf, .xlsx, .zip, .7z, .jpg, .png"
          onChange={handleChangeUploadNote}
          // fileList={uploadFileCV}
          className=""
          maxCount={1}
          beforeUpload={(file) => {
            const checkSize = file.size / 1024 / 1024 > 50;
            if (checkSize) {
              openNotificationWithIcon(
                "error",
                "Lỗi",
                `File vượt đã quá 50MB !`
              );
              return Upload.LIST_IGNORE;
            }

            form.setFieldsValue({
              file_note: file.name,
            });
            return false;
          }}
          showUploadList={false}
        >
          <span style={{ cursor: "pointer" }}>
            <UploadOutlined /> Tải lên
          </span>
        </Upload>
      </>
    );
  };

  const downloadFile = async (fileId, fileName) => {
    try {
      authAxios(cookies.get("token"))
        .get(url_download_note_cv(fileId), { responseType: "blob" })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
      // const response = await axios.get(`/api/download/${fileId}/`, {
      //   responseType: "blob",
      //   withCredentials: true,
      // });
    } catch (error) {
      console.error("Lỗi tải file:", error);
    }
  };

  return (
    <Modal
      title={
        typeEditForm == true
          ? `Chỉnh sửa hồ sơ (${
              dataDetailCandidate && dataDetailCandidate.code_cv
            })`
          : "Chi tiết hồ sơ"
      }
      open={isModalOpenEditCandidate}
      onCancel={() => {
        handleCancelEditCandidate();
        form.resetFields();
      }}
      width={850}
      footer={false}
      className={"resize-form"}
      bodyStyle={{ height: 700, overflowY: "scroll" }}
    >
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={(values) => {
          onFinishEdit(values);
        }}
        // onFinishFailed={onFinishFailed}
        // loading={loading}
        initialValues={{
          remember: true,
        }}
        validateMessages={validateMessages}
        className="disabled-form-candidate"
      >
        <Row className="modal-edit-candidate-row">
          <Col span={6}>
            <Form.Item
              label="Họ và tên"
              className="modal-edit-cadidate-form-item"
              name="first_name"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập họ tên!",
                },
                {
                  pattern: /^[a-zA-ZÀ-ỹ0-9]+(?:\s[a-zA-ZÀ-ỹ0-9]+)*$/,
                  message: "Họ và Tên có khoảng trắng bị thừa / sai định dạng!",
                },
                {
                  min: 3,
                  message: "Họ và Tên phải có ít nhất 3 ký tự!",
                },
              ]}
            >
              <Input placeholder="Họ và tên" disabled={!typeEditForm}></Input>
            </Form.Item>
          </Col>
          <Col span={5} offset={1}>
            <Form.Item
              label="Ngày sinh"
              className="modal-edit-cadidate-form-item"
              name="birthday"
            >
              <DatePicker
                suffixIcon={null}
                placeholder="DD/MM/YYYY"
                // onChange={handleStartDate}
                format={dateFormat}
                disabledDate={disabledDate}
                // value={startDate}
                disabled={!typeEditForm}
              />
            </Form.Item>
          </Col>

          <Col span={5} offset={1}>
            <Form.Item
              label="Giới tính"
              className="modal-edit-cadidate-form-item"
              name="gender"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Radio.Group
                onChange={onChangeCheckBoxGender}
                disabled={!typeEditForm}
              >
                <Radio value={"Nam"}>Nam</Radio>
                <Radio value={"Nữ"}>Nữ</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={5} offset={1}>
            <Form.Item
              label="Số điện thoại"
              className="modal-edit-cadidate-form-item"
              name="numberphone"
              rules={[
                {
                  required: true,
                },
                {
                  pattern: /^\d+$/,
                  message: "Số điện thoại chỉ được nhập bằng số.",
                },
                {
                  min: 10,
                  message: "Số điện thoại có ít nhất 10 ký tự",
                },
                {
                  max: 12,
                  message: "Số điện thoại có tối đa 12 ký tự",
                },
              ]}
            >
              <Input
                placeholder="Số điện thoại"
                disabled={!typeEditForm}
              ></Input>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              label="Tỉnh/Thành phố"
              className="modal-edit-cadidate-form-item"
              name="city_code"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                onChange={(e) => handleChangeListCity(e)}
                allowClear={true}
                placeholder="Chọn Tỉnh/Thành phố"
                showSearch={true}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                disabled={!typeEditForm}
              >
                {ls_city != undefined &&
                  ls_city.map((city) => (
                    <Select.Option key={city.code} value={city.code}>
                      {city.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={5} offset={1}>
            <Form.Item
              label="Quận/Huyện"
              className="modal-edit-cadidate-form-item"
              name="district_code"
              // rules={[
              //   {
              //     required: true,
              //   },
              // ]}
            >
              <Select
                placeholder="Quận/Huyện"
                value={selectedDistrict}
                onChange={setSelectedDistrict}
                disabled={!typeEditForm}
              >
                {listDistrict != undefined &&
                  listDistrict.map((district) => (
                    <Select.Option key={district.code} value={district.code}>
                      {district.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={11} offset={1}>
            <Form.Item
              label="Địa chỉ"
              className="modal-edit-cadidate-form-item"
              name="address"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập địa chỉ!",
                },
                {
                  pattern: /^[a-zA-ZÀ-ỹ0-9,.\-/]+(?:\s[a-zA-ZÀ-ỹ0-9,.\-/]+)*$/,
                  message: "Địa chỉ không hợp lệ! Hãy kiểm tra lại.",
                },
                {
                  min: 5,
                  message: "Địa chỉ phải có ít nhất 5 ký tự!",
                },
              ]}
            >
              <Input placeholder="Địa chỉ" disabled={!typeEditForm}></Input>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Email"
              className="modal-edit-cadidate-form-item"
              name="email"
              rules={[{ type: "email" }]}
            >
              <Input placeholder="Email" disabled={!typeEditForm}></Input>
            </Form.Item>
          </Col>
          <Col span={5} offset={1}>
            <Form.Item
              label="Người phụ trách"
              className="modal-edit-cadidate-form-item"
              name="ls_user_received"
              tooltip="Người xử lý Ticket"
            >
              <Select
                mode="multiple"
                dropdownRender={(menu) => (
                  <div onClick={handleClickUserReceived}>{menu}</div>
                )}
                defaultValue={
                  dataDetailCandidate &&
                  dataDetailCandidate.data_user_received.map((item) => item.id)
                }
                maxTagCount={1}
              >
                {dataDetailCandidate &&
                  dataDetailCandidate.data_user_received != undefined &&
                  dataDetailCandidate.data_user_received.map((item) => (
                    <Select.Option
                      key={item.id}
                      value={item.id}
                      disabled
                      className="style-disabled-form-yctd"
                    >
                      {item.username}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={5} offset={1}>
            <Form.Item
              label="Người duyệt hồ sơ"
              className="modal-edit-cadidate-form-item"
              name="user_approve_name"
              tooltip="Người thay đổi trạng thái của hồ sơ"
            >
              <Input placeholder="Username" disabled></Input>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Trình độ học vấn"
              name="education_level"
              className="modal-edit-cadidate-form-item"
            >
              {!typeEditForm ? (
                <Input disabled></Input>
              ) : (
                <Select>
                  {listEducationLevel.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={5} offset={1}>
            <Form.Item
              label="Trình độ ngoại ngữ"
              name="language_skill"
              className="modal-add-cadidate-form-item"
            >
              <Input disabled={!typeEditForm}></Input>
              {/* {!typeEditForm ? (
                <Input disabled></Input>
              ) : (
                <Select disabled={!typeEditForm}>
                  {listLanguageSkill.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              )} */}
            </Form.Item>
          </Col>
          <Col span={5} offset={1}>
            <Form.Item
              label="Ngày ứng tuyển"
              className="modal-edit-cadidate-form-item"
              name="application_date"
            >
              <DatePicker
                suffixIcon={null}
                placeholder="DD/MM/YYYY"
                // onChange={handleStartDate}
                format={dateFormat}
                disabled={!typeEditForm}
              />
            </Form.Item>
          </Col>
          <Col span={5} offset={1}>
            <Form.Item
              label="Nguồn ứng viên"
              className="modal-edit-cadidate-form-item"
              name="candidate_source"
            >
              {!typeEditForm ? (
                <Input disabled></Input>
              ) : (
                <Select
                  placeholder="Nguồn ứng viên"
                  disabled={!typeEditForm}
                  allowClear
                >
                  {listCandidateSource != undefined &&
                    listCandidateSource.map((item) => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.name}
                      </Select.Option>
                    ))}
                </Select>
              )}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Chuyên ngành"
              className="modal-edit-cadidate-form-item"
              name="education_major"
              rules={[
                {
                  pattern: /^[a-zA-ZÀ-ỹ0-9]+(?:\s[a-zA-ZÀ-ỹ0-9]+)*$/,
                  message: "Ký tự không hợp lệ.",
                },
                {
                  min: 2,
                  message: "Chuyên ngành phải có ít nhất 2 ký tự!",
                },
              ]}
            >
              <Input
                placeholder="Chuyên ngành"
                disabled={!typeEditForm}
              ></Input>
            </Form.Item>
          </Col>

          <Col span={11} offset={1}>
            {typeEditForm ? (
              <Form.Item
                label={
                  <div style={{ width: "100%" }}>
                    File CV: &nbsp;{" "}
                    {dataDetailCandidate && (
                      <>
                        <a
                          href={
                            localhost +
                            "/" +
                            dataDetailCandidate.path_file_cv +
                            "/" +
                            dataDetailCandidate.name_file_cv
                          }
                          className="show-text-a"
                          title={
                            localhost +
                            "/" +
                            dataDetailCandidate.path_file_cv +
                            "/" +
                            dataDetailCandidate.name_file_cv
                          }
                          target="_blank"
                        >
                          {dataDetailCandidate.name_file_cv}
                        </a>
                        {dataDetailCandidate.path_file_cv != null && (
                          <Popconfirm
                            title="Xác nhận xóa file CV？"
                            okText="Xóa"
                            cancelText="Thoát"
                            onConfirm={() =>
                              onDeleleFileCV(dataDetailCandidate)
                            }
                          >
                            <Button
                              type="dashed"
                              danger
                              className="btn-del-edit-cv"
                              size="small"
                              icon={<DeleteOutlined />}
                            ></Button>
                          </Popconfirm>
                        )}
                      </>
                    )}
                  </div>
                }
                name="file_upload"
              >
                <Input addonAfter={<ComponentUploadFile />} disabled></Input>
              </Form.Item>
            ) : (
              <Form.Item label={<>File CV: &nbsp; </>} name="file_upload">
                {dataDetailCandidate && (
                  <a
                    href={
                      localhost +
                      "/" +
                      dataDetailCandidate.path_file_cv +
                      "/" +
                      dataDetailCandidate.name_file_cv
                    }
                  >
                    {dataDetailCandidate.name_file_cv}
                  </a>
                )}
              </Form.Item>
            )}
          </Col>
          {/* <Col span={11} offset={2}>
            <Form.Item
              label={
                <>
                  Ghi chú &nbsp; <i>{dataDetailCandidate.note_date}</i>
                </>
              }
              name="note"
            >
              <Input.TextArea
                autoSize={{
                  minRows: 2,
                }}
                disabled={isEdit}
              />
            </Form.Item>
          </Col> */}
          <Col span={12}>
            <Form.Item
              label="Trạng thái"
              className="modal-edit-cadidate-form-item"
              name="cv_status"
              rules={[{ required: true }]}
            >
              <Select placeholder="Chọn trạng thái" disabled={!typeEditForm}>
                {listStatusCV.map((v) => (
                  <Select.Option key={v.id} value={v.id}>
                    {v.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={11} offset={1}>
            <Form.Item
              label="Lý do chuyển trạng thái"
              className="modal-edit-cadidate-form-item"
              name="why_change"
            >
              <Input.TextArea
                autoSize={{
                  minRows: 1,
                }}
                placeholder={
                  typeEditForm ? "Nhập lý do chuyển trạng thái" : null
                }
                disabled={!typeEditForm}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Ghi chú / File phỏng vấn"
              className="modal-edit-cadidate-form-item"
              name="note"
            >
              <Input placeholder={"Nhập ghi chú"} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              className="modal-edit-cadidate-form-item"
              name="file_note"
            >
              <Input
                addonAfter={<ComponentUploadFileNote />}
                placeholder={
                  "File không quá 50MB (.doc, .docx, .pdf, .xlsx, .zip, .7z, .jpg, .png)"
                }
                disabled
              ></Input>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={13} style={{ textAlign: "right" }}>
            <Form.Item style={{ display: "inline-block" }}>
              <Button type="primary" htmlType="submit">
                Lưu
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Space direction="vertical" size="middle" style={{ display: "flex" }}>
        <Card
          title={
            <Row>
              <Col sm={21}>
                <span>Lịch sử ghi chú hồ sơ</span>
              </Col>
              <Col sm={3} style={{ textAlign: "end" }}>
                <Button
                  title="Tải lại"
                  size="small"
                  shape="circle"
                  loading={loadingNote}
                  // style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                  onClick={
                    loadingNote
                      ? null
                      : () => onReloadNote(dataDetailCandidate.id)
                  }
                  icon={<ReloadOutlined />}
                ></Button>
              </Col>
            </Row>
          }
          loading={loadingNote}
          size="small"
          headStyle={{
            backgroundColor: "#a1a1a152",
            borderRadius: "10px 10px 0px 0px",
          }}
          bodyStyle={{
            backgroundColor: "#a1a1a152",
            borderRadius: "0px 0px 10px 10px",
          }}
        >
          {dataNoteCV &&
            dataNoteCV.map((item) => (
              <div>
                <h4>
                  <a>{item.fore_user__username}</a>
                  <span> - </span>{moment(item.created).format("DD/MM/YYYY HH:mm:ss")}
                </h4>
                {(() => {
                  return (
                    <>
                      <Row>
                        <Col sm={24}>
                          <span>{item.content}</span>
                        </Col>
                        {item.data_file.length != 0 && (
                          <Col sm={24}>
                            <a
                              onClick={() =>
                                downloadFile(
                                  item.data_file[0].id,
                                  item.data_file[0].file_name
                                )
                              }
                            >
                              {item.data_file[0].file_name}
                            </a>
                          </Col>
                        )}
                      </Row>
                    </>
                  );
                })()}
                <Divider
                  style={{ margin: "10px 0", borderTop: "1px solid #a5a5a5" }}
                />
              </div>
            ))}
        </Card>
      </Space>
    </Modal>
  );
};

export default ModalEditCandidate;
